import { useEffect } from "react";
import { useExpertApplicationActions } from "@/hooks/useExpertApplicationActions";
import { useApplicationStatusUpdater } from "@/hooks/useApplicationStatusUpdater";
import { ExpertApplication } from "@/types/admin";

export function useExpertApplicationsActions(
  applications: ExpertApplication[],
  loading: boolean,
  publishedLoading: boolean,
  onDataRefresh: () => Promise<void>
) {
  const { handleStatusUpdate, handleDeleteApplication } = useExpertApplicationActions(async () => {
    await onDataRefresh();
  });

  const { createMissingExpertProfiles } = useApplicationStatusUpdater(() => {});

  useEffect(() => {
    if (!loading && !publishedLoading && applications.length > 0) {
      createMissingExpertProfiles().then(() => {
      });
    }
  }, [loading, publishedLoading, applications.length]);

  const onStatusUpdate = async (applicationId: string, status: 'approved' | 'rejected', adminNotes: string, selectedApplication: ExpertApplication | null, setActiveTab: (tab: string) => void) => {
    try {
      await handleStatusUpdate(applicationId, status, adminNotes, selectedApplication);
      
      if (status === 'rejected') {
        setActiveTab('rejected');
      } else if (status === 'approved') {
        setActiveTab('approved');
      }
    } catch (error) {
    }
  };

  const onDeleteApplication = (applicationId: string) => {
    handleDeleteApplication(applicationId);
  };

  return {
    onStatusUpdate,
    onDeleteApplication
  };
}
